module.exports = __webpack_public_path__ + "static/media/labore_logo_big.6a7c7804.png";